"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Heading = /** @class */ (function (_super) {
    __extends(Heading, _super);
    function Heading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Heading.prototype.render = function () {
        var _a = this.props, className = _a.className, colour = _a.colour, size = _a.size, tag = _a.tag, title = _a.title;
        var sizes = {
            h1: (!className || (className && !className.includes("text-")) ? " text-60" : "") + " \n      " + (!className || (className && !className.includes("font-")) ? " font-extrabold" : "") + "\n      " + (!className || (className && !className.includes("leading-")) ? " leading-normal" : "") + (!className || (className && !className.includes("tracking-")) ? " tracking-normal" : ""),
            h2: (!className || (className && !className.includes("text-36")) ? " text-36" : "") + " " + (!className || (className && !className.includes("leading-")) ? " leading-normal" : "") + (!className || (className && !className.includes("tracking-")) ? " tracking-normal" : ""),
            h3: "text-xmd md:text-lg " + (!className || (className && !className.includes("leading-")) ? " leading-normal" : "") + (!className || (className && !className.includes("tracking-")) ? " tracking-normal" : ""),
            h4: "text-xmd " + (!className || (className && !className.includes("leading-")) ? " leading-normal" : "") + (!className || (className && !className.includes("tracking-")) ? " tracking-wide" : ""),
            h5: "text-base " + (!className || (className && !className.includes("leading-")) ? " leading-normal" : "") + (!className || (className && !className.includes("tracking-")) ? " tracking-normal" : ""),
            h6: "text-sm " + (!className || (className && !className.includes("leading-")) ? " leading-normal" : "") + (!className || (className && !className.includes("tracking-")) ? " tracking-normal" : ""),
            p: "text-base " + (!className || (className && !className.includes("leading-")) ? " leading-normal" : "") + (!className || (className && !className.includes("tracking-")) ? " tracking-normal" : "")
        };
        var style = size && sizes[size] ? sizes[size] : sizes.p;
        var classes = "" + style + (className ? " " + className : "");
        var elements = {
            h1: (React.createElement("h1", { className: classes, title: title || null }, this.props.children)),
            h2: (React.createElement("h2", { className: classes, title: title || null }, this.props.children)),
            h3: (React.createElement("h3", { className: classes, title: title || null }, this.props.children)),
            h4: (React.createElement("h4", { className: classes, title: title || null }, this.props.children)),
            h5: (React.createElement("h5", { className: classes, title: title || null }, this.props.children)),
            h6: (React.createElement("h6", { className: classes, title: title || null }, this.props.children)),
            p: (React.createElement("p", { className: classes, title: title || null }, this.props.children)),
            label: (React.createElement("label", { className: classes, title: title || null }, this.props.children))
        };
        return !tag && elements[size] ? elements[size] : tag && elements[tag] ? elements[tag] : elements.p;
    };
    return Heading;
}(React.PureComponent));
exports.Heading = Heading;
